import React from 'react';
import { Breadcrumb } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { startCase } from 'lodash';
import { useMediaQuery } from 'react-responsive';
import { useLocation, Link } from 'react-router-dom';

const nonMenu = [
	'pengetahuan-umum',
	'kewarganegaraan',
	'bahasa-indonesia',
	'bahasa-inggris',
	'matematika',
	'tpa',
	'kecerdasan',
	'kepribadian',
	'tkm',
	'passhanda2',
	'angka-hilang',
	'huruf-hilang',
	'simbol-hilang',
	'campuran',
	'renang',
	'shuttle-run',
	'pull-up',
	'push-up',
	'sit-up',
	'lari-12-menit',
];

const excluedMenus = ['result', 'live-class'];

const CustomBreadCrumb = () => {
	const location = useLocation();
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const pathnames = location.pathname.split('/').filter((x) => x);

	const isExcludeBreadcrumb = pathnames.some((item) =>
		excluedMenus.includes(item)
	);

	if (isMobile || pathnames.length === 1 || isExcludeBreadcrumb) {
		return null;
	}

	return (
		<Breadcrumb separator={<RightOutlined style={{ fontSize: '10px' }} />}>
			{pathnames.map((value, index) => {
				const last = index === pathnames.length - 1;
				const to = `/${pathnames.slice(0, index + 1).join('/')}`;
				const formattedValue = startCase(value);
				const isNotMenu = nonMenu.includes(value);

				return last || isNotMenu ? (
					<Breadcrumb.Item key={to}>{formattedValue}</Breadcrumb.Item>
				) : (
					<Breadcrumb.Item key={to}>
						<Link to={to}>{formattedValue}</Link>
					</Breadcrumb.Item>
				);
			})}
		</Breadcrumb>
	);
};

export default CustomBreadCrumb;
